import { render, staticRenderFns } from "./boxList.vue?vue&type=template&id=0850ce40&scoped=true"
import script from "./boxList.vue?vue&type=script&lang=js"
export * from "./boxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0850ce40",
  null
  
)

export default component.exports